// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xwu6","label":"styles_label__3zUTH"};